import React, { useState } from 'react';
import api from '../../utils/axios';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';
import { toast } from 'sonner';
import { Users } from 'lucide-react';

export const MonitoresPorCuitAccion = ({ onDone }) => {
  const { user } = useAuth();
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  if (!['ADMIN', 'SUPERADMIN', 'ADMINISTRADOR'].includes((user?.rol || '').toUpperCase())) return null;

  const correr = async (ejecutar) => {
    setLoading(true);
    try {
      const res = await api.post(`/monitors-migracion/agrupar-por-cuit?ejecutar=${ejecutar}`);
      if (ejecutar) {
        const bk = res.data.backup;
        toast.success(`${res.data.cambiados} monitor(es) pasados a CUIT${bk ? ` · backup ${bk.coleccion} (${bk.total_en_backup} monitores)` : ''}`, { duration: 8000 });
        setPreview(null);
        onDone?.();
      } else {
        setPreview(res.data);
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error');
    } finally {
      setLoading(false);
    }
  };

  const p = preview;
  return (
    <>
      <Button variant="outline" onClick={() => correr(false)} disabled={loading} data-testid="monitores-por-cuit-btn">
        <Users size={16} className="mr-2" /> Agrupar por CUIT (5 monitores)
      </Button>
      <AlertDialog open={!!p} onOpenChange={(o) => { if (!o) setPreview(null); }}>
        <AlertDialogContent data-testid="monitores-por-cuit-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Vista previa: agrupar por Cliente (CUIT)</AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="space-y-2 text-sm text-slate-600">
                <p data-testid="monitores-por-cuit-a-cambiar">A cambiar: {p?.a_cambiar?.length || 0}</p>
                {p?.a_cambiar?.map((m) => <p key={m.id} className="pl-3">· {m.nombre}: {m.antes} → cuit</p>)}
                {p?.ya_en_cuit?.length > 0 && <p>Ya agrupan por CUIT: {p.ya_en_cuit.join(', ')}</p>}
                {p?.no_encontrados?.length > 0 && <p className="text-amber-700">No encontrados: {p.no_encontrados.join(', ')}</p>}
                {p?.a_cambiar?.length > 0 && <p>Antes de cambiar se copia la colección de monitores a un respaldo del día.</p>}
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="monitores-por-cuit-cancelar">Cerrar</AlertDialogCancel>
            {p?.a_cambiar?.length > 0 && (
              <AlertDialogAction onClick={() => correr(true)} data-testid="monitores-por-cuit-confirmar">Aplicar</AlertDialogAction>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
